import Repository from "./Repository";
import axios from "axios";
import { baseURL } from "./Repository";
import _ from "lodash";

//API CALL for Guest flow
class GuestRepository extends Repository {
  onGetAllQuizList = async (params) => {
    try {
      const data = await this.getData(`admin/quiz/fetch`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onCreateQuiz = async (params) => {
    console.log(params, "params");
    try {
      const data = await this.postData("admin/quiz/create", params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onGetSingleQuizData = async (quizId) => {
    try {
      const data = await await this.getData(
        `admin/quiz/fetchById/${quizId}`,
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onGetSingleQuestionAndAnswers = async (quizeId) => {
    console.log(quizeId, "quizeId");
    try {
      const data = await await this.getData(
        `admin/question/fetchQnA/${quizeId}`,
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onDeleteQuiz = async (quizId) => {
    try {
      const data = await this.deleteData(`admin/quiz/delete/${quizId}`, {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onUpdateQuizState = async (params) => {
    try {
      const data = await this.putData(`admin/quiz/activateDeactivate`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onGetCourseWeeksData = async (courseId) => {
    try {
      const data = await this.getData(
        `admin/quiz/weekDropdown/${courseId}`,
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onGetQuizSubmissionHistory = async (params) => {
    try {
      // Build query string with all parameters
      const queryParams = new URLSearchParams();
      
      if (params?.page) queryParams.append('page', params.page);
      if (params?.per_page) queryParams.append('per_page', params.per_page);
      if (params?.search) queryParams.append('search', params.search);
      if (params?.quiz_id) queryParams.append('quiz_id', params.quiz_id);
      if (params?.user_id) queryParams.append('user_id', params.user_id);
      if (params?.user_name) queryParams.append('user_name', params.user_name);
      if (params?.email) queryParams.append('email', params.email);
      if (params?.attempts) queryParams.append('attempts', params.attempts);
      if (params?.finished_at) queryParams.append('finished_at', params.finished_at);

      const queryString = queryParams.toString();
      const data = await this.fetchdata(
        `admin/quiz/submissionList?${queryString}`,
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onCreateQuestion = async (params, quizId) => {
    try {
      const data = await this.uploadForm(
        "admin/question/questionsAnswers",
        params
      );
      return { data: _.get(data, `data`), quizId };
    } catch (error) {
      return { error };
    }
  };

  onDeleteQuestion = async (questionId) => {
    try {
      const data = await this.deleteData(
        `admin/question/delete/${questionId}`,
        {}
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  addFeedbackAssessment = async (params) => {
    try {
      const data = await this.putData(`admin/quiz/addFeedback`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  assessmentQuestionNReasonAdmin = async (params) => {
    try {
      const data = await this.postData(
        "admin/quiz/questionWiseAssessment",
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onDeleteAttempt = async (params) => {
    try {
      const data = await this.postData(`admin/quiz/deleteAttempt`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onUpdateQuiz = async (params) => {
    try {
      const data = await this.postData(`admin/quiz/update`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onUpdateQuestion = async (params) => {
    try {
      const data = await this.postData(`admin/question/update`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  resetAttempts = async (params) => {
    try {
      const data = await this.postData("admin/quiz/resetAttempts", params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  resetAllAttempts = async (params) => {
    try {
      const data = await this.postData("admin/quiz/resetAllAttempts", params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };

  onGetAttemptgraph = async (params) => {
    try {
      const data = await this.postData(
        `admin/quiz/studentAttemptGraph`,
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  getCategoryList = async () => {
    try {
      const data = await this.getData(`admin/quiz/categories`, {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  addCategory = async (params) => {
    try {
      const data = await this.postData(`admin/quiz/categories`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  getSubjectList = async () => {
    try {
      const data = await this.getData(`admin/quiz/subjects`, {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  addSubject = async (params) => {
    console.log(params, "params");
    try {
      const data = await this.postData(`admin/quiz/subjects`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  editCategory = async (params) => {
    try {
      const data = await this.putData(`admin/quiz/categories/${params.id}`, {
        name: params.name,
      });
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  deleteCategory = async (id) => {
    try {
      const data = await this.deleteData(`admin/quiz/categories/${id}`, {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  editSubject = async (params) => {
    try {
      const data = await this.putData(`admin/quiz/subjects/${params.id}`, {
        name: params.name,
        parent_subject_id: params.parent_subject_id,
      });
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  deleteSubject = async (id) => {
    try {
      const data = await this.deleteData(`admin/quiz/subjects/${id}`, {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  addQuestion = async (params, quizId) => {
    try {
      const data = await this.postData(`admin/question/addQuestion`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  getQuestions = async (params) => {
    console.log(params, "paramsss");
    try {
      const data = await this.postData(`admin/question/fetchQuestions`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  addQuestiontoQuiz = async (params) => {
    console.log(params, "Qurstions params");
    try {
      const data = await this.postData(
        `admin/question/addQuestionsToQuiz`,
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  removeQuestionfromQuiz = async (params) => {
    console.log(params, "Qurstions params");
    try {
      const data = await this.postData(
        `admin/question/removeQuestionFromQuiz`,
        params
      );
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  rearrangeQuestions = async (params) => {
    try {
      const data = await this.postData(`admin/quiz/rearrangeQuestions`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  fetchGrades = async (params) => {
    console.log(params, "params");
    try {
      const data = await this.postData(`admin/quiz/grades/fetch`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  addGrades = async (params) => {
    try {
      const data = await this.postData(`admin/quiz/grades/add`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  updateGrade = async (params) => {
    try {
      const data = await this.putData(`admin/quiz/grades/edit`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  editQuestion = async (params) => {
    try {
      const data = await this.postData(`admin/question/updateQuestion`, params);
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  deleteQuestion = async (params) => {
    try {
      const data = await this.deleteData(`admin/question/delete/${params}`, {});
      return _.get(data, `data`);
    } catch (error) {
      return { error };
    }
  };
  downloadCSV = async (params = {}) => {
    try {
      // Build query string from params
      const queryParams = new URLSearchParams();
      
      // Add v=1 parameter
      queryParams.append('v', '1');
      
      // Add filter parameters (URLSearchParams automatically URL-encodes values)
      if (params.search) queryParams.append('search', params.search);
      if (params.quiz_id) queryParams.append('quiz_id', params.quiz_id);
      if (params.user_id) queryParams.append('user_id', params.user_id);
      if (params.user_name) queryParams.append('user_name', params.user_name);
      if (params.email) queryParams.append('email', params.email);
      if (params.attempts) queryParams.append('attempts', params.attempts);
      if (params.finished_at) queryParams.append('finished_at', params.finished_at);

      const queryString = queryParams.toString();
      const url = `${baseURL}api/v1/admin/quiz/downloadScoresCSV?${queryString}`;
      
      // Get auth token
      const access_token = localStorage.getItem("token") || "";

      // Use axios directly for better error handling
      const response = await axios({
        method: 'GET',
        url: url,
        responseType: "blob",
        headers: {
          Authorization: access_token.length > 0 ? `Bearer ${access_token}` : `Bearer`,
          Accept: "application/json",
        },
      });

      // Check HTTP status code - if it's an error status, handle it
      if (response.status >= 400) {
        let errorMessage = "Failed to download CSV file";
        
        // Try to extract error message from blob response
        if (response.data instanceof Blob) {
          const errorText = await response.data.text();
          try {
            const errorJson = JSON.parse(errorText);
            errorMessage = errorJson.message || errorJson.error || errorMessage;
          } catch (e) {
            // Not JSON, use the text as error message if it's reasonable length
            if (errorText.length < 500) {
              errorMessage = errorText || errorMessage;
            }
          }
        }
        
        throw new Error(errorMessage);
      }

      // Check if response is actually a blob and not empty
      if (!response || !response.data) {
        throw new Error("Empty response from server");
      }

      const blob = new Blob([response.data], { type: "text/csv" });
      
      // Check if blob size is 0 (empty file)
      if (blob.size === 0) {
        throw new Error("Empty file received from server");
      }

      // Read blob as text to check for errors
      const text = await blob.text();
      
      // If blob is very small (like 15 bytes), it's likely an error response
      if (blob.size < 100) {
        // Check if it's JSON error
        try {
          const json = JSON.parse(text);
          if (json.error || json.status_code === 0 || json.status === false) {
            throw new Error(json.message || json.error || "Error downloading CSV");
          }
        } catch (e) {
          // If it's not JSON but very small, it's likely an error
          if (text.length < 50) {
            throw new Error(text || "Error downloading CSV - received invalid response");
          }
        }
      }

      // Check if response might be an error JSON instead of CSV
      let jsonError = null;
      try {
        const json = JSON.parse(text);
        if (json.error || json.status_code === 0 || json.status === false) {
          jsonError = json.message || json.error || "Error downloading CSV";
        }
      } catch (e) {
        // Not JSON, so it's likely a valid CSV
      }

      if (jsonError) {
        throw new Error(jsonError);
      }

      // Recreate blob from text (since we read it to check for JSON errors)
      const csvBlob = new Blob([text], { type: "text/csv" });
      const urlObj = window.URL.createObjectURL(csvBlob);
      const link = document.createElement("a");
      link.href = urlObj;

      // Create human-readable date format: YYYY-MM-DD_HH-mm-ss
      const now = new Date();
      const dateStr = now.toISOString().slice(0, 10); // YYYY-MM-DD
      const timeStr = now.toTimeString().slice(0, 8).replace(/:/g, '-'); // HH-mm-ss
      let filename = `quiz_scores_${dateStr}_${timeStr}.csv`;

      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(urlObj);

      return { success: true, message: "CSV downloaded successfully" };
    } catch (error) {
      console.error("Error downloading CSV:", error);
      // Handle axios errors
      if (error.response) {
        // Server responded with error status
        let errorMessage = "Failed to download CSV file";
        if (error.response.data instanceof Blob) {
          try {
            const errorText = await error.response.data.text();
            const errorJson = JSON.parse(errorText);
            errorMessage = errorJson.message || errorJson.error || errorMessage;
          } catch (e) {
            errorMessage = `Server error: ${error.response.status} ${error.response.statusText}`;
          }
        } else if (error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else {
          errorMessage = `Server error: ${error.response.status} ${error.response.statusText}`;
        }
        return { error: errorMessage, success: false };
      }
      return { error: error.message || error, success: false };
    }
  };
}

export default new GuestRepository("quiz");
